import { useTranslation } from "react-i18next";

/**
 * App mark — references the same /icon.svg used by the PWA manifest, so
 * there's exactly one owl drawing to keep in sync (per the "no emoji as
 * icons" rule, this is the closest thing Chouette has to a wordmark glyph).
 *
 * The corner radius follows the drawing's own (rx 96 on a 512 box), so the
 * mark reads as the home-screen icon at any size instead of turning into a
 * pill once it gets small.
 */
export function Logo({ size = 48, className = "" }: { size?: number; className?: string }) {
  return (
    <img
      src="/icon.svg"
      width={size}
      height={size}
      alt=""
      style={{ borderRadius: (size * 96) / 512 }}
      className={`inline-block ${className}`}
    />
  );
}

/**
 * Logo + nom de l'app, en tête des écrans connectés : sans lui, une fois
 * passée la page de connexion, rien dans l'app ne rappelait l'icône posée
 * sur l'écran d'accueil du téléphone.
 */
export function BrandMark({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Logo size={28} />
      <span className="font-heading font-bold text-lg leading-none text-paper">{t("common.appName")}</span>
    </div>
  );
}
